import { fetch } from 'utils/fetch';
import { getMyProfile } from 'api/main';
import { getQueryString } from '@/utils/environment';

export default {
  udeskSignature: function (params) {
    return new Promise((resolve, reject) => {
      fetch({
        url: '/api/udesk/redirect',
        method: 'get',
        params: params,
      })
        .then((res) => {
          this.getAuthCodeAndLocationInfo(res.data.redirectUri)
            .then((resCode) => {
              res.data.redirectUri = `${res.data.redirectUri}${resCode.url}`;
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  //未登录/绑定 时 获取的客服链接
  udeskSignatureUnbind: function (params) {
    return fetch({
      url: '/api/udesk/unchecked/redirect',
      method: 'get',
      params: params,
    });
  },

  getLocation: function () {
    return new Promise((resolve, reject) => {
      getMyProfile()
        .then((res) => {
          const { OTHER: { FEEDBACK: { link } = {} } = {} } = res.data || {};
          let redirectUri = decodeURIComponent(getQueryString('redirect_uri', link));
          let properties = ['href', 'origin', 'host', 'hostname', 'port', 'pathname', 'search', 'hash'];
          let result = {};
          let linkElem = document.createElement('a');
          linkElem.href = redirectUri;
          for (let i = 0, len = properties.length; i < len; i++) {
            result[properties[i]] = linkElem[properties[i]];
          }
          resolve(result);
        })
        .catch((err) => {
          resolve({
            host: 'apph5.huilianyi.com',
            origin: 'https://apph5.huilianyi.com',
          });
          // reject(err);
        });
    });
  },

  getAuthCodeAndLocationInfo: function (redirectUri) {
    return new Promise((resolve, reject) => {
      this.getAuthCode()
        .then(async (res) => {
          const location = await this.getLocation();
          const params = {
            data: {},
          };
          params.data.authorizationCode = res.data.authorizationCode;
          params.data.originHost = location.host;
          params.data.origin = location.origin;
          const encodeData = encodeURIComponent(JSON.stringify(params.data));
          params.url = `&code=${res.data.authorizationCode}&encodeData=${encodeData}#/feedback`;
          resolve(params);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  getAuthCode: function () {
    return fetch({
      url: '/api/auth/code/current/user',
      method: 'get',
    });
  },
};
